'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ON_RECONCILIATION: 'ON_RECONCILIATION',
  ON_REQUEST: 'ON_REQUEST'
};